interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
  >
    <g clipPath="url(#clip0_487_12135)">
      <path
        d="M15 2.5H2.5V37.5H15V2.5ZM37.5 2.5H25V15H37.5V2.5ZM37.5 25V37.5H25V25H37.5ZM0 2.5C0 1.83696 0.263392 1.20107 0.732233 0.732233C1.20107 0.263392 1.83696 0 2.5 0L15 0C15.663 0 16.2989 0.263392 16.7678 0.732233C17.2366 1.20107 17.5 1.83696 17.5 2.5V37.5C17.5 38.163 17.2366 38.7989 16.7678 39.2678C16.2989 39.7366 15.663 40 15 40H2.5C1.83696 40 1.20107 39.7366 0.732233 39.2678C0.263392 38.7989 0 38.163 0 37.5V2.5ZM22.5 2.5C22.5 1.83696 22.7634 1.20107 23.2322 0.732233C23.7011 0.263392 24.337 0 25 0L37.5 0C38.163 0 38.7989 0.263392 39.2678 0.732233C39.7366 1.20107 40 1.83696 40 2.5V15C40 15.663 39.7366 16.2989 39.2678 16.7678C38.7989 17.2366 38.163 17.5 37.5 17.5H25C24.337 17.5 23.7011 17.2366 23.2322 16.7678C22.7634 16.2989 22.5 15.663 22.5 15V2.5ZM25 22.5C24.337 22.5 23.7011 22.7634 23.2322 23.2322C22.7634 23.7011 22.5 24.337 22.5 25V37.5C22.5 38.163 22.7634 38.7989 23.2322 39.2678C23.7011 39.7366 24.337 40 25 40H37.5C38.163 40 38.7989 39.7366 39.2678 39.2678C39.7366 38.7989 40 38.163 40 37.5V25C40 24.337 39.7366 23.7011 39.2678 23.2322C38.7989 22.7634 38.163 22.5 37.5 22.5H25Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_487_12135">
        <rect width="40" height="40" fill={color} />
      </clipPath>
    </defs>
  </svg>
);

export default SVG;
